var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "div",
        {
          staticClass: "app-main-page",
          staticStyle: {
            height: "calc(100vh - 100px)",
            "align-items": "stretch"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", flex: "1", height: "100%" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    flex: "1",
                    height: "auto",
                    border: "1px solid #ccc"
                  }
                },
                [
                  _c("div", { staticClass: "app-main-inner-row" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              inline: true,
                              "label-width": "80px",
                              "label-position": "left"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "el-form-item-wrapper" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t("CargoMsg.Cargo_BusinessType") +
                                        ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_SystemConstants$LOBS,
                                        "static-options": _vm.lobs,
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.queryData.lob
                                      },
                                      on: {
                                        parentCallBack: _vm.lobChangeHandler
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "SystemMaintenance.BusinessMode"
                                        ) + ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        disabled: !_vm.queryData.lob,
                                        filterable: "",
                                        "callback-method-type": "value",
                                        "static-options": _vm.operateTypeList,
                                        "default-value":
                                          _vm.queryData.operateType,
                                        "tag-name": "chineseName",
                                        "tag-value": "code"
                                      },
                                      on: {
                                        parentCallBack: _vm.onOperateTypeChange
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "100px",
                                      label:
                                        _vm.$t("CargoMsg.Cargo_CustomJobType") +
                                        ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        disabled: !_vm.queryData.lob,
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_CutomJobType,
                                        filterable: "",
                                        "method-params": {
                                          type: _vm.queryData.lob,
                                          active: true
                                        },
                                        "default-value":
                                          _vm.queryData.customJobType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.queryData.customJobType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t("CargoMsg.Cargo_AirlineCode") +
                                        ":"
                                    }
                                  },
                                  [
                                    _vm.isSea || _vm.isAir
                                      ? _c("cargo-advance-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            disabled: !_vm.queryData.lob,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Region,
                                            filterable: "",
                                            "default-value":
                                              _vm.queryData.region,
                                            "tag-name": "code"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.queryData.region = p.value
                                            }
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            disabled: !_vm.queryData.lob,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_RailwayLine,
                                            filterable: "",
                                            "default-value":
                                              _vm.queryData.region,
                                            "tag-name": "code"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.queryData.region = p.value
                                            }
                                          }
                                        })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "SystemMaintenance.AirlineChineseName"
                                        ) + ":"
                                    }
                                  },
                                  [
                                    _vm.isSea || _vm.isAir
                                      ? _c("cargo-advance-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            disabled: !_vm.queryData.lob,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Region,
                                            filterable: "",
                                            "default-value": _vm.region2,
                                            "tag-name": "name"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.region2 = p.value
                                            }
                                          }
                                        })
                                      : _c("cargo-advance-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            disabled: !_vm.queryData.lob,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_RailwayLine,
                                            filterable: "",
                                            "default-value": _vm.region2,
                                            "tag-name": "name"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.region2 = p.value
                                            }
                                          }
                                        })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    [
                                      _vm.isAir
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.LoadingPort"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          )
                                        : _vm.isRailway
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_DepartureStation"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("CargoMsg.Cargo_POL")
                                                ) + ":"
                                              )
                                            ]
                                          )
                                    ],
                                    [
                                      _vm.isSea || _vm.isAir
                                        ? _c("cargo-advance-select", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              disabled: !_vm.queryData.lob,
                                              "select-type": _vm.isSea
                                                ? _vm.selectTypeNames
                                                    .basic_data_Seaport
                                                : _vm.selectTypeNames
                                                    .basic_data_Airport,
                                              filterable: "",
                                              "callback-params": {
                                                key: "loadingPortCode"
                                              },
                                              "default-value":
                                                _vm.queryData.loadingPortCode
                                            },
                                            on: {
                                              parentCallBack: _vm.setQueryData
                                            }
                                          })
                                        : _c("cargo-advance-select", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              disabled: !_vm.queryData.lob,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_RailwayStation,
                                              filterable: "",
                                              "callback-params": {
                                                key: "loadingPortCode"
                                              },
                                              "default-value":
                                                _vm.queryData.loadingPortCode
                                            },
                                            on: {
                                              parentCallBack: _vm.setQueryData
                                            }
                                          })
                                    ]
                                  ],
                                  2
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    [
                                      _vm.isAir
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "queryJob.portOfDestination"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          )
                                        : _vm.isRailway
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_DestinationStation"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              attrs: { slot: "label" },
                                              slot: "label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "queryJob.dischargingPortCode"
                                                  )
                                                ) + ":"
                                              )
                                            ]
                                          )
                                    ],
                                    [
                                      _vm.isSea || _vm.isAir
                                        ? _c("cargo-advance-select", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              disabled: !_vm.queryData.lob,
                                              "select-type": _vm.isSea
                                                ? _vm.selectTypeNames
                                                    .basic_data_Seaport
                                                : _vm.selectTypeNames
                                                    .basic_data_Airport,
                                              filterable: "",
                                              "callback-params": {
                                                key: "code"
                                              },
                                              "default-value":
                                                _vm.queryData.code
                                            },
                                            on: {
                                              parentCallBack: _vm.setQueryData
                                            }
                                          })
                                        : _c("cargo-advance-select", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              disabled: !_vm.queryData.lob,
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_RailwayStation,
                                              filterable: "",
                                              "callback-params": {
                                                key: "code"
                                              },
                                              "default-value":
                                                _vm.queryData.code
                                            },
                                            on: {
                                              parentCallBack: _vm.setQueryData
                                            }
                                          })
                                    ]
                                  ],
                                  2
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "CargoMsg.Cargo_DestinationAgent"
                                        ) + ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        filterable: "",
                                        disabled: !_vm.isSeAe,
                                        "tag-name": "englishName",
                                        "options-width": "150px;",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Company,
                                        "method-params": { overseaAgent: true },
                                        "default-value":
                                          _vm.queryData.destinationAgent || ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.queryData.destinationAgent =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "100px",
                                      label:
                                        _vm.$t(
                                          "SystemMaintenance.RelatedUser"
                                        ) + ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames.basic_data_User,
                                        "callback-params": { key: "userId" },
                                        "callback-method-type": "value",
                                        "default-value": _vm.queryData.userId,
                                        filterable: ""
                                      },
                                      on: { parentCallBack: _vm.setQueryData }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label:
                                        _vm.$t(
                                          "SystemMaintenance.OperationPosition"
                                        ) + ":"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          filterable: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.queryData.role,
                                          callback: function($$v) {
                                            _vm.$set(_vm.queryData, "role", $$v)
                                          },
                                          expression: "queryData.role"
                                        }
                                      },
                                      _vm._l(_vm.allRole, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.code
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.opOffice") + ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Office_All,
                                        filterable: "",
                                        "static-options": _vm.officeList,
                                        "default-value": _vm.queryData.opOffice,
                                        "tag-name": "code"
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.queryData.opOffice = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "80px",
                                      label: _vm.$t("SeaExport.CargoType") + ":"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_CargoType,
                                        "method-params": _vm.isAir
                                          ? { air: true }
                                          : { sea: true },
                                        disabled: !_vm.queryData.lob,
                                        filterable: "",
                                        "default-value": _vm.queryData.cargoType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.queryData.cargoType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "80px",
                                      label:
                                        _vm.$t("CargoMsg.Cargo_Carrier") + ":"
                                    }
                                  },
                                  [
                                    _vm.queryData.lob === "SE"
                                      ? _c("cargo-company-select", {
                                          attrs: {
                                            "method-params": {
                                              companyLob: "seaExport",
                                              seaCmp: true,
                                              active: true
                                            },
                                            "default-value":
                                              _vm.queryData.carrierId,
                                            "custom-style": "width: 200px"
                                          },
                                          on: {
                                            change: function(p) {
                                              _vm.queryData.carrierId = p.value
                                            }
                                          }
                                        })
                                      : _vm.queryData.lob === "SI"
                                      ? _c("cargo-company-select", {
                                          attrs: {
                                            "method-params": {
                                              companyLob: "seaImport",
                                              seaCmp: true,
                                              active: true
                                            },
                                            "default-value":
                                              _vm.queryData.carrierId,
                                            "custom-style": "width: 200px"
                                          },
                                          on: {
                                            change: function(p) {
                                              _vm.queryData.carrierId = p.value
                                            }
                                          }
                                        })
                                      : _vm.queryData.lob === "AE"
                                      ? _c("cargo-company-select", {
                                          attrs: {
                                            "method-params": {
                                              companyLob: "airExport",
                                              airCmp: true,
                                              active: true
                                            },
                                            "default-value":
                                              _vm.queryData.carrierId,
                                            "custom-style": "width: 200px"
                                          },
                                          on: {
                                            change: function(p) {
                                              _vm.queryData.carrierId = p.value
                                            }
                                          }
                                        })
                                      : _vm.queryData.lob === "AI"
                                      ? _c("cargo-company-select", {
                                          attrs: {
                                            "method-params": {
                                              companyLob: "airImport",
                                              airCmp: true,
                                              active: true
                                            },
                                            "default-value":
                                              _vm.queryData.carrierId,
                                            "custom-style": "width: 200px"
                                          },
                                          on: {
                                            change: function(p) {
                                              _vm.queryData.carrierId = p.value
                                            }
                                          }
                                        })
                                      : _vm.queryData.lob === "IE" &&
                                        _vm.queryData.operateType === "IC"
                                      ? _c("cargo-company-select", {
                                          attrs: {
                                            "method-params": {
                                              companyLob: "integratedJob",
                                              truckCmp: true,
                                              active: true
                                            },
                                            "default-value":
                                              _vm.queryData.carrierId,
                                            "custom-style": "width: 200px"
                                          },
                                          on: {
                                            change: function(p) {
                                              _vm.queryData.carrierId = p.value
                                            }
                                          }
                                        })
                                      : _c("el-select", {
                                          staticStyle: { width: "200px" },
                                          attrs: {
                                            disabled: "",
                                            value: "",
                                            placeholder: " "
                                          }
                                        })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { "label-width": "0" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            return _vm.loadUserPort(1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Query"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.addUserPortClickEvent }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_add"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.editUserPortClickEvent
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Edit"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                        attrs: { type: "danger" },
                                        on: { click: _vm.delUserPortClickEvent }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Delete")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                        attrs: {
                                          value: _vm.config.value === "1"
                                        },
                                        on: { input: _vm.onConfigInput }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.ConfigApplyRemoteBooking"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: { "margin-right": "20px" },
                                        attrs: {
                                          value:
                                            _vm.manualSelectIfMultipleConfig
                                              .value === "1"
                                        },
                                        on: {
                                          input:
                                            _vm.onManualSelectIfMultipleConfigInput
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.NotSetDefaultValueMultiPosition"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          value:
                                            _vm.notUpdateConfig.value === "1"
                                        },
                                        on: {
                                          input: _vm.onNotUpdateConfigInput
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.BusinessDataNotUpdate"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", "flex-grow": "1" },
                    attrs: {
                      "config-module": "2022082204",
                      "column-defs": _vm.port.columnDefs,
                      "row-data": _vm.port.rowData,
                      "grid-options": _vm.port.gridOptions
                    },
                    on: { gridReady: _vm.onReady }
                  }),
                  _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "2022082204",
                          total: _vm.queryData.total,
                          "page-count": _vm.queryData.pageCount,
                          page: _vm.queryData.pageNum,
                          limit: _vm.queryData.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.queryData, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.queryData, "pageSize", $event)
                          },
                          pagination: function() {
                            if (_vm.queryData.total > 0) {
                              _vm.loadUserPort()
                            }
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("add-user-port-window", {
        ref: "addUserPortWindow",
        attrs: {
          visible: _vm.addUserPort.visible,
          action: _vm.addUserPort.action
        },
        on: {
          cancelHandler: _vm.addCancelHandler,
          saveSuccessHandler: _vm.saveSuccessHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }